import Zendesk, { ZendeskAPI } from 'react-zendesk';

function ZendeskComponent() {
  const setting = {
    color: {
      theme: '#000',
    },
    launcher: {
      chatLabel: {
        'en-US': 'Need Help',
      },
    },
    contactForm: {
      fields: [
        { id: 'description', prefill: { '*': 'My pre-filled description' } },
      ],
    },
  };
  return (
    <Zendesk
      defer
      zendeskKey={process.env.NEXT_PUBLIC_ZENDESK_KEY}
      {...setting}
      onLoaded={() => ZendeskAPI('webWidget', 'hide')}
    />
  );
}
export default ZendeskComponent;
